import { IonModal } from '@ionic/react'
import styled from 'styled-components'
import { BODY_MAX_WIDTH } from '~/shared/ui/theme'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Dialog = styled(IonModal)`
  --background: ${myPalette.aliceBlue.main};
  --height: auto;
  --border-radius: 16px;
  padding: 24px;

  .ion-page {
    width: 100%;
  }

  &::part(content) {
    --width: min(calc(100% - 32px), calc(${BODY_MAX_WIDTH} - 32px));
    overflow-x: hidden;
    padding: 24px;
    margin: 0;
    display: flex;
    justify-content: center;
  }
`
